import { StyleFunctionProps } from '@chakra-ui/styled-system';

export const LinkStyle = {
  baseStyle: () => ({
    marginBottom: '4',
  }),

  size: {
   
  },
  variants: {
    normal: (props: StyleFunctionProps) => ({
        fontWeight: 'normal',
        '_activeLink': {
            color: props.theme.colors.tertiary,
            fontWeight: 'bold',
        },
        '_hover': {
          color: props.theme.colors.tertiary,
            textDecoration:'none',
        }
    }),
  
  },
  defaultProps: {
    variant: 'normal'
  },
};